import VError from 'verror';

import { createHttp } from 'utils/http';
import { LIFECYCLE_STATUS } from 'common/constants/lifecycle-and-health-mappings';
import notify from 'utils/notify';

const http = createHttp();

const actions = {
    closeDealAdsModal: () => {
        return dispatch => {
            dispatch({
                type: 'DEAL_ADS_MODAL__CLOSE_MODAL',
            });
        };
    },
    showDealAdsDetails: dealId => {
        return async dispatch => {
            dispatch({
                type: 'DEAL_ADS_MODAL__DETAILS_INIT',
            });

            const query = `
                query getDealAdsData($dealId: String, $campaignLifeCycleCurrentStates: [campaignLifeCycleCurrentStateEnum]) {
                    deals(filter: {dealIds: [$dealId], campaignLifeCycleCurrentStates: $campaignLifeCycleCurrentStates}) {
                      id
                      app_name
                      category
                      ads {
                        id
                        name
                        start
                        end
                        dealApplicationType
                        status
                        campaign {
                            id
                            lifecycle {
                              current_state
                          }
                          name
                        }
                        organizationData {
                          name
                        }
                      }
                    }
                }
            `;
            const variables = {
                dealId,
                campaignLifeCycleCurrentStates: [
                    LIFECYCLE_STATUS.pending,
                    LIFECYCLE_STATUS.started,
                ],
            };

            try {
                const { deals } = await http.graphql(query, variables);
                dispatch({
                    type: 'DEAL_ADS_MODAL__DETAILS_DATA_END',
                    payload: { deal: deals[0] },
                });
            } catch (error) {
                dispatch({
                    type: 'DEAL_ADS_MODAL__DETAILS_DATA_ERROR',
                });

                if (error.response.status === 401) {
                    return;
                }

                notify({
                    error: new VError(error, `Failed to fetch ads for deal id ${dealId}`),
                    metaData: {
                        ...variables,
                    },
                });
            }
        };
    },
};

export default actions;
